export default "__VITE_ASSET__KFJeRcgZ__"